import { theme } from '@thg-commerce/gravity-theme'
import { Property } from 'csstype'

export type ImageTextBlockThemeInterface = {
  container: {
    backgroundColor: Property.Color
  }
}

export const ImageTextBlockTheme: ImageTextBlockThemeInterface = {
  container: {
    backgroundColor: theme.colors.palette.greys.lighter,
  },
}
